import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { ADD_LINK_REQUEST, GET_LINK_MANAGEMENT_REQUEST, STATUS_LINK_CHANGE_REQUEST } from "./type";
import {
    addEditLinkManagementSuccess,
    changeLinkStatusSuccess,
    getLinkManagementRequest,
    getLinkManagementSuccess
} from "./action";
import { handleApiCallException } from "../../shared/action";
import { ApiResponseMessage } from "../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../constant/commonConstants";
import { invokeApi } from "../../../helper/axiosHelper";
import { getInquiryRequest } from "../inquiry/action";

function* LinkList({ payload: data }) {
    try {
        const response = yield call(invokeApi, "post", "/linkList", data);
        if (response.status) {
            yield put(getLinkManagementSuccess(response.data));
        } else {
            yield put(getLinkManagementSuccess(response));
            ApiResponseMessage(response.message, DANGER);
            handleApiCallException(response.message);
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error);
    }
}
function* AddEditLink({ payload: data }) {
    try {
        const response = yield call(invokeApi, "post", "/createEditLink", data.values);
        if (response.status) {
            yield put(addEditLinkManagementSuccess(response));
            ApiResponseMessage(response.message, SUCCESS);
            yield put(getLinkManagementRequest(data.dispatchData));
            data.onModalDismiss()
        } else {
            yield put(getLinkManagementRequest(response));
            ApiResponseMessage(response.message, DANGER);
            handleApiCallException(response.message);
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error);
    }
}
function* LinkStatus({ payload: data }) {
    try {
        const response = yield call(invokeApi, "post", "/statusLink", data.status);
        if (response.status) {
            yield put(changeLinkStatusSuccess(response.data));
            ApiResponseMessage(response.message, SUCCESS);
            yield put(getLinkManagementRequest(data.dispatchData));

        } else {
            yield put(changeLinkStatusSuccess(response));
            ApiResponseMessage(response.message, DANGER);
            handleApiCallException(response.message);
        }
    } catch (error) {
        ApiResponseMessage(error, DANGER);
        handleApiCallException(error);
    }
}

function* watchLinkRequest() {
    yield takeLatest(GET_LINK_MANAGEMENT_REQUEST, LinkList);
    yield takeLatest(STATUS_LINK_CHANGE_REQUEST, LinkStatus);
    yield takeLatest(ADD_LINK_REQUEST, AddEditLink);
}

function* LinkSaga() {
    yield all([fork(watchLinkRequest)]);
}

export default LinkSaga;
